// extracted by mini-css-extract-plugin
export default {"page-size-controls":"page-size-controls-component_page-size-controls__DlZdM"};